import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ roles, children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F4F5F0]">
        <div className="text-[#0A1128] font-mono text-sm tracking-widest">LOADING…</div>
      </div>
    );
  }
  if (!user) {
    // SC users live on the mobile OTP entry point, not the staff /login page.
    const isScRoute = loc.pathname.startsWith("/sc");
    const isAppRoute = loc.pathname.startsWith("/app") && !loc.pathname.startsWith("/app/quote") && !loc.pathname.startsWith("/app/survey");
    return <Navigate to={isScRoute ? "/sc/signup" : isAppRoute ? "/app/login" : "/login"} state={{ from: loc }} replace />;
  }
  if (roles && !roles.includes(user.role)) {
    // redirect each role to its home
    if (user.role === "admin" || user.role === "sales_employee") return <Navigate to="/crm" replace />;
    if (user.role === "technician") return <Navigate to="/fsm" replace />;
    if (user.role === "sc") return <Navigate to="/sc" replace />;
    if (user.role === "service_team") return <Navigate to="/service" replace />;
    return <Navigate to="/app" replace />;
  }
  return children;
}
